// extracted by mini-css-extract-plugin
export default {"FeatureP":"FeatureP_FeatureP__xEr7B","LessLineHeight":"FeatureP_LessLineHeight__AKblO"};